import { Image, Text } from '@atoms/index';
import texts from '@components/ReferAndEarn/en.json';
import ReferralInfo from '@components/ReferAndEarn/ReferralInfo';
import { replaceKeysWithValues } from '@helpers/miscelleanous';
import {
    hasOffer,
    newRewardForReferringTenFriends,
    rewardForReferringTenFriends,
} from '@components/ReferAndEarn/helper';

const ReferAndEarnBanner = ({ referralLink }) => {
    return (
        <div className="relative pt-8 mx-4 md:pt-10 lg:mx-0 md:w-full">
            <div className="pt-[124px] w-full">
                <div className="bg-basicWhite rounded-2xl shadow-lg-custom px-4 md:px-6 pb-6 pt-8 flex flex-col gap-6 w-full mx-auto max-w-[769px]">
                    <div className="flex flex-col items-center gap-2 max-w-[504px] mx-auto">
                        <Text
                            content={texts?.ReferEarnRepeat}
                            className="text-transparent h4-semibold md:h3-semibold bg-blue-gradient bg-clip-text"
                            htmlTag="h1"
                        />
                        <div className="p4-regular text-gray-700 flex flex-col items-center text-center max-w-[704px]">
                            <Text
                                content={
                                    hasOffer
                                        ? replaceKeysWithValues(
                                              texts?.DoubleRewardsBanner
                                                  ?.IntroduceYourFriends,
                                              {
                                                  '{previousReward}':
                                                      rewardForReferringTenFriends,
                                                  '{newReward}':
                                                      newRewardForReferringTenFriends,
                                              }
                                          )
                                        : replaceKeysWithValues(
                                              texts?.IntroduceYourFriends,
                                              {
                                                  '{referralReward}':
                                                      rewardForReferringTenFriends,
                                              }
                                          )
                                }
                                isInnerHtml
                            />
                        </div>
                    </div>
                    <ReferralInfo
                        referralLink={referralLink}
                        buttonText={texts?.StartReferringToday}
                    />
                </div>
            </div>
            <Image
                src="/images/homepage/jiraaf-mascot-2.webp"
                className="absolute -translate-x-1/2 top-8 md:top-10 left-1/2 z-[1] w-[160px]"
                alt="mr-j"
            />
        </div>
    );
};

export default ReferAndEarnBanner;
